import * as React from 'react';
import { EInputTextType } from '../index';

interface IProps {
  isFocused: boolean;
  isLoading: boolean;
  name?: string;
  value?: string[] | string | number;
  placeholder: string;
  type: string;
  onChange?: (name: string, value: string) => void;
  additionalClass?: string;
  isDisabled?: boolean;
  inputTextType?: EInputTextType;
  onBlur?: any;
  autoFocus?: boolean;
  readOnly?: boolean;
  maxLength?: number;
  min?: number;
  max?: number;
  step?: string;
  id?: any;
  cols?: number;
  rows?: number;
}

interface IState {
  isFocused: boolean;
}

export class Textarea extends React.Component<IProps, IState> {
  private inputRef: HTMLTextAreaElement;
  private focusTimeoutId;

  constructor(props: any) {
    super(props);
    this.state = {
      isFocused: false,
    };
  }

  public componentDidMount() {
    this.focusTimeoutId = setTimeout(() => {
      if (this.props.isFocused) {
        this.inputRef.focus();
      }
    }, 0);
  }

  public componentWillUnmount() {
    clearTimeout(this.focusTimeoutId);
  }

  public render() {
    const { name, value, placeholder, isFocused, isLoading, isDisabled, readOnly, rows, cols } = this.props;

    return (
      <textarea
        name={name}
        placeholder={placeholder}
        onBlur={this.handleBlur}
        onFocus={this.handleFocus}
        readOnly={readOnly}
        onChange={this.handleChange}
        className={'textarea'}
        ref={(input) => isFocused && (this.inputRef = input)}
        autoFocus={isFocused}
        disabled={isDisabled || isLoading}
        autoComplete='off'
        cols={cols || 30}
        rows={rows || 10}
      >
        {value}
      </textarea>
    );
  }

  private handleChange = (e) => {
    const name = e.currentTarget.name;
    const value = e.currentTarget.value;
    this.props.onChange && this.props.onChange(name, value);
  };

  private handleFocus = (e) => {
    this.setState({ isFocused: true });
  };

  private handleBlur = (e) => {
    this.props.onBlur && this.props.onBlur(e);
  };
}
